import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'

import { I18n } from 'aws-amplify'

import { useMe } from '../../../../../presentation/contexts/me'

import { makeMe } from '../../../../usecases/me/load-me-factory'
import { makeUsers } from '../../../../usecases/users/remote-users-factory'

import Signin from '../../../../../presentation/pages/common/amplify/signin'

import {
  HelperAmplify,
  LocalStorage,
} from '../../../../../presentation/helpers'
import { RoutesEnum, Authority } from '../../../../../presentation/enums'

const MakeSignin = (): JSX.Element => {
  document.title = 'BuscarMédicos - Entrar'

  const history = useHistory()

  const [errorMessage, setErrorMessage] = useState<string | null>('')

  const { me, updateMe } = useMe()

  useEffect(() => {
    const handleDoctorRedirect = async (_me: any) => {
      const subscriptions = await makeUsers().loadSubscription(_me.id)
      const { hasPendingPayment } = subscriptions[subscriptions.length - 1]
      LocalStorage.set('hasPendingPayment', hasPendingPayment ? '1' : '')
      history.push(RoutesEnum.HOME_DOCTOR)
    }

    const redirectToHome = async () => {
      if (!me) return

      LocalStorage.set('authority', me.profiles[0].authority)
      if (me.profiles[0].authority === Authority.DOCTOR) {
        await handleDoctorRedirect(me)
      } else if (me.profiles[0].authority === Authority.CONTRACTOR) {
        history.push(RoutesEnum.HOME_CONTRACTOR)
      }
    }

    if (me?.confirmedAccount) {
      redirectToHome()
    }
  }, [me, history])

  const handleBackClick = (evt: React.MouseEvent<HTMLButtonElement>): void => {
    evt.preventDefault()
    history.goBack()
  }

  const handleSubmit = async (values: any): Promise<void> => {
    const { email, password } = values

    try {
      await HelperAmplify.signIn(email, password)

      const response = await makeMe().load()

      if (response.confirmedAccount) {
        updateMe(response)
        LocalStorage.set('authority', response.profiles[0].authority)
      } else {
        setErrorMessage(
          'Confirme sua conta clicando no link enviado ao e-mail cadastrado.',
        )
      }
    } catch (error: any) {
      const msg = I18n.get(error.name)
      setErrorMessage(msg)
    }
  }

  const dataForm = [
    {
      items: [
        {
          name: 'email',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'email',
          title: 'E-mail',
          label: 'E-mail',
          required: true,
          validations: 'emailRequired',
          style: { marginBottom: '15px' },
        },
        {
          name: 'password',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Senha',
          label: 'Senha',
          required: true,
          secureTextEntry: true,
          passwordInput: true,
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Entrar',
          submittingText: 'Entrando...',
        },
        {
          name: 'forgot-password',
          href: 'forgot-password',
          component: 'Link',
          title: 'Esqueci a senha',
        },
      ],
    },
  ]

  const props = {
    dataForm,
    onSubmit: handleSubmit,
    errorMessage,
    handleBackClick,
  }

  return <Signin {...props} />
}

export default MakeSignin
